import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Box, Button, Container, Typography, CircularProgress, Card, CardContent } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { TextBox } from 'devextreme-react/text-box';
import { useTranslation } from 'react-i18next';
import { updatePassword } from '../../redux/users/thunks';
import { selectUser } from '../../redux/authentication/selectors';
import { getUserData } from '../../redux/authentication/thunks';
import { parseJwtToken } from '../../commonFunctions/commonFunctions';
import { ROUTE_PANEL } from '../routes/routesConstants';

export const ForceChangePassword = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector(selectUser);

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        if (e) {
            e.preventDefault();
        }
        setError(null);

        if (!currentPassword || !newPassword || !confirmPassword) {
            setError(t("PleaseFillAllFields"));
            return;
        }

        if (newPassword !== confirmPassword) {
            setError(t("PasswordsDoNotMatch"));
            return;
        }

        setIsSubmitting(true);
        try {
            const params = {
                body: {
                    UserId: user.user.userId,
                    Password: currentPassword,
                    NewPassword: newPassword
                }
            };
            const response = await dispatch(updatePassword(params)).unwrap();
            
            if (response === true) {
                const token = parseJwtToken();
                await dispatch(getUserData({ param: token.sub }));
                history.replace(ROUTE_PANEL);
            } else {
                setError(t("UpdatePasswordFail"));
            }
        } catch (err) {
            setError(err?.message || t("UpdatePasswordFail"));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Container component="main" maxWidth="sm">
            <Box style={{ marginTop: '4rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Card style={{ minWidth: 275, width: '100%', padding: '1rem' }}>
                    <CardContent>
                        <Typography component="h1" variant="h5" style={{ marginBottom: '1.5rem', fontWeight: 'bold' }}>
                            {t("ForceChangePasswordTitle")}
                        </Typography>
                        <Typography variant="body1" color="textSecondary" style={{ marginBottom: '2rem' }}>
                            {t("ForceChangePasswordDescription")}
                        </Typography>

                        {error && (
                            <Box style={{ marginBottom: '1.5rem' }}>
                                <Alert severity="error">
                                    {error}
                                </Alert>
                            </Box>
                        )}

                        <form onSubmit={handleSubmit} noValidate>
                            <Box style={{ marginBottom: '1.5rem' }}>
                                <TextBox
                                    mode="password"
                                    label={t("CurrentPassword")}
                                    labelMode="floating"
                                    value={currentPassword}
                                    onValueChanged={(e) => setCurrentPassword(e.value)}
                                    width="100%"
                                />
                            </Box>
                            
                            <Box style={{ marginBottom: '1.5rem' }}>
                                <TextBox
                                    mode="password"
                                    label={t("NewPassword")}
                                    labelMode="floating"
                                    value={newPassword}
                                    onValueChanged={(e) => setNewPassword(e.value)}
                                    width="100%"
                                />
                            </Box>
                            
                            <Box style={{ marginBottom: '2rem' }}>
                                <TextBox
                                    mode="password"
                                    label={t("ConfirmNewPassword")}
                                    labelMode="floating"
                                    value={confirmPassword}
                                    onValueChanged={(e) => setConfirmPassword(e.value)}
                                    width="100%"
                                />
                            </Box>

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit}
                                disabled={isSubmitting || !currentPassword || !newPassword || !confirmPassword || newPassword !== confirmPassword}
                                style={{ paddingTop: '12px', paddingBottom: '12px' }}
                            >
                                {isSubmitting ? <CircularProgress size={24} color="inherit" /> : t("ConfirmNewPasswordBtn")}
                            </Button>
                        </form>
                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
};
